import http from "@/api/api";
import failOrderTip from "./components/failOrderTip.vue";
import MyIconComponent from "./components/MyIconComponent.vue";
var isPro = process.env.NODE_ENV === "production";
export default class WebSocketClient {

  // 单例模式创建websocket客户端：
  static instance = null;

  // 方法前面加get，调用时不用加小括号，判断此类是否被创建了对象，如果创建了的话就直接return
  static get Instance() {
    if (!this.instance) {
      this.instance = new WebSocketClient();
    }
    return this.instance;
  }

  // ws为websocket实例对象，下面会赋WebSocket对象寄存器地址给ws
  ws = null;

  // 定义一个是否连接成功的标识，来解决当服务没有连接就请求数据报错的bug
  connected = false;

  // 记录重连ws服务器的次数（可用于延迟发送请求和延迟掉线重连服务）：
  reConnectCount = 0;

  //  临时回调函数容器,存储回调函数用来接收数据：以socket匹配名称为key，函数寄存器地址为value
  callBackMap = {};

  connectionPromise = null;

  //是否为主动断开
  idisconnect = false;

  // 连接服务器：
  // 掉线重新连接定时器id
  timeId = null;
  connect(id) {
    if (!window.WebSocket) {
      return console.log("浏览器不支持WebSocket");
    }
    // 创建连接，先判断当前浏览器是否支持WebSocket,支持的话创建websocket客户端并将寄存器地址赋值给ws变量
    if ("WebSocket" in window) {
      if (!this.connectionPromise) {
        // 创建websocket客户端对象，并连接到指定服务器：(后端项目所在服务器ip才可以访问到，否则连接失败!)
        let ip = http.processRequest.split("//")[1]
        if(isPro){
          this.ws = new WebSocket(`ws:${ip}/ws/message/${id}`);
        }else{
          this.ws = new WebSocket(`ws:${ip}/ws/message/${id}`);

        }
        this.idisconnect = false;
      }

      //可以直接绑定域名
      // this.ws = new WebSocket('ws://******.com:3001')

      this.connectionPromise = new Promise((resolve) => {
        // 监听客户端与服务端连接成功：
        this.ws.onopen = () => {
          // 将是否连接的状态修改为已经连接成功
          this.connected = true;
          // 并将掉线重连次数重新赋值为0
          this.reConnectCount = 0;
          // 连接成功后将掉线重连定时器停止：
          clearInterval(this.timeId);
          console.log("连接websocket服务器成功！");
        };

        // 监听服务器主动断开或连接失败：
        this.ws.onclose = () => {
          // 当服务器主动断开或连接失败时，将是否连接状态修改为未连接，并将掉线重连次数累加
          this.connectionPromise = null;
          this.connected = false;
          this.reConnectCount++;
          console.log("服务器主动断开了连接");
          // 当监听到与服务端断开后，每隔一段时间调用自己connect尝试重新连接服务器,当连接成功后在监听连接成功的事件中停止定时器
          this.timeId = setTimeout(() => {
            console.log(this.idisconnect);
            if (this.idisconnect == true) {
              console.log("主动断开，不再连接");
              return;
            } else {
              this.connect(JSON.parse(localStorage.getItem("user")).id);
            }
          }, this.reConnectCount * 1000);
        };

        // 监听服务器端发送数据过来：
        this.ws.onmessage = (response) => {
          let obj =  JSON.parse(response.data) ;
          if(response){
            let titleHandle = {
              'meeting':'会议通知',
              'system':'系统通知',
              'check':'安全检查审批通知',
              'safeCheck':'安全检查通知',
              'checkCollect':'安全检查汇总通知',
              'dangerAssign':'隐患指派整改审批通知',
              'dangers':'隐患整改验收审批通知',
              'dangersCheck':'隐患检查',
              'checkSign':'安全检查签到通知',
              'officialOrdinary':'公文通知',
              'promiseOrdinary':'承诺书通知',
              'riskCollect':'风险初审通知',
              'certifies':'证书消息通知',
              'sign':'签到通知',
              'constructionPlan':'生产计划审批',
              'riskIdetion':'风险管控',
              'official':'公文信息',
              'vote':'确认票信息',
              'course':'课程通知',
              'fence':'电子围栏'

            }

            this.newvue.$toast.info({
              component: failOrderTip,
              listeners: {
                goMsg: () => this.$toast.success("跳转成功!")
              },
              props: {
                title:titleHandle[obj.type],
                obj,
                newVue:this.newvue,
              }
            }, {
              position: "top-right",
              timeout: 10000,
              icon: MyIconComponent

            });

          }
          // 拿到后端返回数据中的websocket标识符api的值，调用回调函数将数据传给回调函数
          const api = response.api;
          if (this.callBackMap[api]) {
            this.callBackMap[api].call(this, response);
          }
          console.log( this.callBackMap);
        };
      });

      return this.connectionPromise;
    } else {
      alert(
        "您的浏览器不支持Websocket通信协议，请使用Chrome或者Firefox浏览器！"
      );
    }
  }

  // 请求的回调函数
  addCallBack(socketType, callBakc) {
    this.callBackMap[socketType] = callBakc;
  }
  // 移出存储回调函数中的某个函数：

  //TODO 断开连接的方法
  disconnect() {
    if (this.connected) {
      this.ws.close();
      this.connected = false;
      this.connectionPromise = null;
      this.idisconnect = true; //表示主动断开
      console.log("断开websocket连接");
    }
  }
  removeCallBack(socketType) {
    console.log("移出回调函数");
    //TODO:断开连接
    this.disconnect();
    this.callBackMap[socketType] = null;
  }

  // 定义发送请求数据的方法，request为请求对象格式：{api:'要匹配的接口', body:{请求体对象}}
  send(request) {
    // 因为我的接口中需要token验证，所以我们将每次请求都加上token值
    const token = window.localStorage.getItem("Authorization");
    let obj;
    obj = { token: token, request };

    // 当ws服务连接成功后才可以发送请求
    if (this.connected) {
      this.ws.send(JSON.stringify(obj));
    } else {
      this.reConnectCount = 0;
      this.reConnectCount++;
      // 否则延迟this.reConnectCount * 500ms再次尝试请求数据,这里不写死时间是因为当多次连接是每次将时间拉长可以减少服务压力
      setTimeout(() => {
        this.ws.send(JSON.stringify(obj));
      }, this.reConnectCount * 1500);
    }
  }
}
